import { render } from "./TierForm.vue?vue&type=template&id=324d8c16"
import script from "./TierForm.vue?vue&type=script&lang=js"
export * from "./TierForm.vue?vue&type=script&lang=js"

import "./TierForm.vue?vue&type=style&index=0&id=324d8c16&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__